import { render } from "./PriceLanding.vue?vue&type=template&id=760b3f18"
import script from "./PriceLanding.vue?vue&type=script&lang=js"
export * from "./PriceLanding.vue?vue&type=script&lang=js"

import exportComponent from "/Users/remy/Sites/baghera/woc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__